import React from 'react';

import { useIntl } from 'react-intl-next';

import { Stack } from '@atlaskit/primitives/compiled';

import { PeriodType } from '../../../constants';
import { messages as commonMessages } from '../../../messages';
import { Card } from '../../card';
import { CloseButton } from '../../card/button';
import { Row } from '../../card/row';
import { DateTime } from '../../card/row/date-time';
import { ReadonlyUser } from '../../card/row/readonly-user';
import { Contact } from '../contact';
import { DeletedWarning, ForwardedInfo } from '../info';

import { type SingleViewShiftCardProps } from './types';

const SingleViewShiftCard = ({ cards, onClose }: SingleViewShiftCardProps) => {
	const intlApi = useIntl();

	const singleCard = cards[0];

	const { rotation, ...period } = singleCard;
	const { responder } = period;

	const isDeleted = responder.deleted;
	const isForwarded = period.from && period.type === PeriodType.Forwarding;

	return (
		<Card
			role="dialog"
			aria-labelledby="shift-card-title"
			controls={<CloseButton onClick={onClose} />}
			content={
				<Stack space="space.200">
					<Stack space="space.150">
						<Contact id="shift-card-title" responder={responder} />

						{isDeleted && <DeletedWarning />}

						{isForwarded && <ForwardedInfo />}
					</Stack>

					<Stack space="space.050">
						<DateTime
							variant="start"
							epoch={period.startEpoch + period.startOffset}
							isTrueTime={period.isTrueStartTime}
						/>

						<DateTime
							variant="end"
							epoch={period.endEpoch + period.endOffset}
							isTrueTime={period.isTrueEndTime}
						/>

						<Row variant="inline" label={intlApi.formatMessage(commonMessages.rotation)}>
							{rotation.name}
						</Row>

						{isForwarded && <ReadonlyUser variant="previousOnCall" responder={period.from!} />}
					</Stack>
				</Stack>
			}
		/>
	);
};

export { SingleViewShiftCard };
